<template>
    <div v-if="fixedHtml">
        <article class="bg-white card">
            <div v-html="fixedHtml"></div>
            <section class="related">
                <h2 class="section-title">Relaterade platser</h2>
                <div class="map-wrapper">
                    <map-component
                            v-if="hasRelatedLocations"
                            :map-id="mapComponentProps['map-id']"
                            :static-map="false"
                            :geo-json="mapComponentProps['geo-json']"
                            :current-location="null"
                            type="location"
                    >
                    </map-component>
                </div>
            </section>
        </article>
    </div>
    <div v-else v-html="html"></div>
</template>

<script>
import MapComponent from '../map-component/MapComponent'

export default {
  name: 'ImageTemplate',
  components: { MapComponent },
  props: ['html'],

  data: function () {
    return {
      fixedHtml: null,
      hasRelatedLocations: false,
      mapComponentProps: undefined
    }
  },

  mounted () {
    const tmpDiv = document.createElement('div')

    tmpDiv.innerHTML = this.html
    // console.log(tmpDiv)
    const mapComponent = tmpDiv.getElementsByTagName('map-component')[0]

    if (mapComponent) {
      tmpDiv.innerHTML = tmpDiv.getElementsByClassName('card')[0].innerHTML
      this.hasRelatedLocations = true
      const props = {}
      _.each(mapComponent.attributes, attribute => {
        props[attribute.nodeName.replace(':', '')] = attribute.nodeValue
      })
      this.mapComponentProps = props

      const relatedLocations = tmpDiv.getElementsByClassName('relatedLocations')[0]
      relatedLocations.parentNode.removeChild(relatedLocations)

      this.fixedHtml = tmpDiv.innerHTML
    }
  },

  methods: {
    relatedLocations: function () {

    }
  },

  computed: {

  },

  watch: {
    html(newHtml) {

    }
  }
}
</script>
